import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { getProductUrl, type ProductHit } from '@libs/algolia';
import { algoliaAutofillTrack, initAlgoliaTracking } from '@libs/analytics';
import type { AutocompleteItem, PanelListProps } from '../types';
import { getSectionTitle } from '../utils';
import { PanelItem } from './PanelItem';
export function PanelList(t0) {
  const $ = _c(23);
  const {
    autocomplete,
    items,
    source,
    highlightedIndex,
    onKeyDown,
    query
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      recentSearchesPlugin: "recent-searches",
      querySuggestionsPlugin: "query-suggestions",
      productSuggestionsPlugin: "product-suggestions"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const autocompleteClasses = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useEffect(_temp, t2);
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== autocomplete || $[3] !== highlightedIndex || $[4] !== items || $[5] !== onKeyDown || $[6] !== query || $[7] !== source) {
    const sectionTitle = source.sourceId === "querySuggestionsPlugin" && query !== "" ? "" : getSectionTitle(source.sourceId);
    const handleItemClick = (item, searchAssistTerm) => {
      const itemName = item.name ?? item.label as string ?? item.objectID;
      window.dispatchEvent(new CustomEvent("getAssistedSearchData", {
        detail: {
          searchTerm: itemName,
          searchAssistTerm,
          searchAssistName: sectionTitle.toLowerCase()
        }
      }));
    };
    t6 = "autocomplete-source";
    t7 = sectionTitle !== "" && <div className="autocomplete-source-header" data-testid="popular-searches">{sectionTitle}</div>;
    t3 = "autocomplete-list";
    if ($[13] !== autocomplete) {
      t4 = autocomplete.getListProps();
      $[13] = autocomplete;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t5 = items.map((item_0, index) => {
      const itemProps = autocomplete.getItemProps({
        item: item_0,
        source
      });
      return <PanelItem className={`autocomplete-${autocompleteClasses[source.sourceId]}`} onKeyDown={onKeyDown} item={item_0} focus={index === highlightedIndex} key={item_0.objectID ?? item_0.label} sourceId={source.sourceId} {...itemProps} onClick={e => {
        const searchInput = document.getElementById("autocmplete-search-box") as HTMLInputElement;
        const searchAssistTerm_0 = searchInput?.value || "";
        handleItemClick(item_0, searchAssistTerm_0);
        const productUrl = getProductUrl(item_0 as ProductHit);
        if (productUrl && item_0.__autocomplete_queryID) {
          algoliaAutofillTrack(item_0);
        }
        return itemProps.onClick(e);
      }} />;
    });
    $[2] = autocomplete;
    $[3] = highlightedIndex;
    $[4] = items;
    $[5] = onKeyDown;
    $[6] = query;
    $[7] = source;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t8 = <ul className={t3} {...t4}>{t5}</ul>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <section className={t6}>{t7}{t8}</section>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
function _temp() {
  initAlgoliaTracking();
}